const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

export const deleteInteraction = async (accessToken, interactionId) => {
  const res = await fetch(`${API_BASE}/contact-interactions/${interactionId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    credentials: 'include',
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const message = data?.detail || data?.message || 'Failed to delete interaction';
    throw new Error(message);
  }
  return true;
};

export const updateInteraction = async (accessToken, interactionId, payload) => {
  const res = await fetch(`${API_BASE}/contact-interactions/${interactionId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const message = data?.detail || data?.message || 'Failed to update interaction';
    throw new Error(message);
  }

  return res.json().catch(() => ({}));
};
